export interface Bonus {
  label: string
  title: string
  subtitle: string
  body: string
}

export const bonuses: Bonus[] = [
  {
    label: '🎁 BONUS 1',
    title: 'GUIDE D’ANATOMIE RADIOLOGIQUE EN COUPES™',
    subtitle: 'S’orienter dans une pile de coupes',
    body: 'La référence de poche pour nommer chaque structure en TDM et en IRM, dans les trois plans, avec des repères d’orientation simples.',
  },
  {
    label: '🎁 BONUS 2',
    title: 'GUIDE NORMAL VS ANORMAL EN IMAGERIE™',
    subtitle: 'Distinguer le normal de l’inhabituel',
    body: 'Région par région : l’aspect normal, la variante anatomique sans conséquence et l’image inhabituelle à signaler au médecin radiologue.',
  },
  {
    label: '🎁 BONUS 3',
    title: 'DÉCODEUR DES DENSITÉS SCANNER ET DES SÉQUENCES IRM™',
    subtitle: 'Blanc, gris ou noir : comprendre pourquoi',
    body: 'L’échelle des densités, le choix de la fenêtre et la reconnaissance des principales séquences IRM au premier coup d’œil.',
  },
  {
    label: '🎁 BONUS 4',
    title: 'CHECK-LISTS DE LECTURE ET DE CONTRÔLE QUALITÉ D’IMAGE™',
    subtitle: 'Ne rien oublier, image après image',
    body: 'Des check-lists imprimables pour lire chaque image dans le bon ordre et valider une acquisition avant de la transmettre.',
  },
  {
    label: '🎁 BONUS 5',
    title: 'CAHIER D’EXERCICES DE RECONNAISSANCE RADIOLOGIQUE™',
    subtitle: 'S’entraîner activement',
    body: 'Des exercices progressifs de repérage, de description et de comparaison, avec des corrigés expliqués.',
  },
]
